<template>
	<div @click="setSlideshow(images)" class="GalleryCard">
		<div class="GalleryCard__image">
			<img :src="require(`@/assets/images/gallery/${folderName}/1.jpg`)" :alt="title">
		</div>
		<div class="GalleryCard__title">
			<h4>{{ title }}</h4>
		</div>
	</div>
</template>

<script>
export default {
	name: 'GalleryCard',
	props: {
		folderName: String,
		title: String,
		images: Array,
		setSlideshow: Function
	}
}
</script>

<style lang="scss" scoped>
.GalleryCard {
	width: 100%;
	height: 100%;
	display: flex;
	position: relative;
	overflow: hidden;
	border-radius: 5px;
	cursor: pointer;
	@include transition(0.1);

	&:hover {
		@include box-shadow(0px 1px 4px 0px rgba(0, 0, 0, 0.75));
	}

	&__image {

		img {
			width: 100%;
			height: 100%;
			border-radius: 5px;
			@include box-shadow(0px 0px 3px 0px rgba(0,0,0,0.75));
		}
	}	

	&__title {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		background: rgba(0, 0, 0, 0.4);

		h4 {
			margin: 0;
			color: white;
			font-size: 2em;
		}
	}

}
</style>
